import React, {Component, Fragment} from 'react';

import ReadyButton from 'components/ReadyButton';
import AudioPlayer from 'components/AudioPlayer';

import no_workingMemoryWordsIntro from 'assets/sounds/no/intros/workingmemory-words-introno.mp3';
import nn_workingMemoryWordsIntro from 'assets/sounds/nn/intros/workingmemory-words-intronn.mp3';
import no_norming_workingMemoryWordsIntro from 'assets/sounds/no/intros/Arbeidsminne-introduction-WORDS.mp3';
import nn_norming_workingMemoryWordsIntro from 'assets/sounds/nn/intros/nn-Arbeidsminne-instruction-WORD.mp3';
import strings from 'strings';
import {TYPES} from '../../constants/index';

class Intro extends Component {
	constructor(props) {
		super(props);
		const {ageGroup, testKeyType} = this.props;
		const isNormingTest =
			ageGroup >= 2 ||
			testKeyType === TYPES.ADULT_FOLLOWUP ||
			testKeyType === TYPES.YOUTH_FOLLOWUP;
		switch (strings.getLanguage()) {
			case 'nn':
				this.audio = isNormingTest
					? nn_norming_workingMemoryWordsIntro
					: nn_workingMemoryWordsIntro;
				break;
			case 'no':
				this.audio = isNormingTest
					? no_norming_workingMemoryWordsIntro
					: no_workingMemoryWordsIntro;
				break;
			default:
				this.audio = no_workingMemoryWordsIntro;
				break;
		}
	}

	render() {
		const {ageGroup, testKeyType} = this.props;
		const isNormingTest =
			ageGroup >= 2 ||
			testKeyType === TYPES.ADULT_FOLLOWUP ||
			testKeyType === TYPES.YOUTH_FOLLOWUP;
		return (
			<Fragment>
				<p>
					<AudioPlayer autoplay inline src={this.audio} />
					{isNormingTest
						? strings.wsw_intro1_norming
						: strings.wsw_intro1}{' '}
					<br />
				</p>
				{!isNormingTest && (
					<ReadyButton onReadyChange={this.props.setReady} />
				)}
			</Fragment>
		);
	}
}

export default Intro;
